import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useLoading from "../../../../Hooks/useLoading";
import { ProjectModel } from "../../../../Models/ProjectModel";
import { ProjectGroupingModel } from "../../../../Models/ProjectGroupingModel";
import { LinesModel } from "../../../../Models/LinesModel";
import { CompanyContext } from "../../../../Contexts/CompanyContext";
import { IResponseProps } from "../../../../Interfaces/IResponseProps";
import { GetAllAssignedProjectByLineIdAPI, GetAllProjectGroupingByLineIdAPI, GetLineById } from "../../../../API/RecommendationAPI";
import CardHeader from "../../../components/CardHeader";
import { AutoComplete, Input, Table, TableProps } from "antd";

export default function ProjectsAssigned() {
    const { id, lineId } = useParams();
    const { loading, toggleLoading } = useLoading();
    const [projects, setProjects] = useState<ProjectModel[]>([]);
    const [projectGroupings, setProjectGroupings] = useState<ProjectGroupingModel[]>([]);
    const [line, setLine] = useState<LinesModel>();
    const [search, setSearch] = useState<string>("");
    const [total, setTotal] = useState<number>(0);
    const { company } = useContext(CompanyContext);
    const [take, setTake] = useState<number>(7);

    const getAllProjectsByLine = async (page?: number) => {
        try {
            toggleLoading(true);

            let text = search == null || search === "" ? "all" : search;

            await GetAllAssignedProjectByLineIdAPI(lineId ?? "", page ?? 1, take, text).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setProjects(resp.data.items);
                    setTotal(resp.data.total);
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }
    const getAllProjectGroupingByLine = async (page?: number) => {
        try {
            toggleLoading(true);

            let text = search == null || search === "" ? "all" : search;

            await GetAllProjectGroupingByLineIdAPI(lineId ?? "", page ?? 1, take, text).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setProjectGroupings(resp.data.items);
                    setTotal(resp.data.total);
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const getLineById = async () => {
        try {
            toggleLoading(true);

            await GetLineById(lineId ?? "").then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setLine(resp.data);
                }
            }).finally(() => toggleLoading(false));

        } catch (error: any) {
            toggleLoading(true);
            toast.error(error);
        }
    }

    useEffect(() => {
        if (lineId) {
            getLineById();
        }
    }, [lineId]);

    useEffect(() => {
        if (line) {
            if (company.potential === 0) {
                getAllProjectsByLine();
            }
            else {
                getAllProjectGroupingByLine();
            }
        }
    }, [line, take]);

    const projectsColumns: TableProps<ProjectModel>['columns'] = [
        {
            key: "name",
            dataIndex: "name",
            showSorterTooltip: { target: 'full-header' },
            filters: projects.map(item => ({
                text: item.name,
                value: item.name,
            })),
            title: "",
            width: '50%'
        }
    ];

    const projectGroupingColumns: TableProps<ProjectGroupingModel>['columns'] = [
        {
            key: "name",
            dataIndex: "name",
            showSorterTooltip: { target: 'full-header' },
            filters: projectGroupings.map(item => ({
                text: item.name,
                value: item.name,
            })),
            title: "",
            width: '50%'
        }
    ];

    return (
        <div className='card ml-2 mr-2'>
            <CardHeader
                pageName={line?.favoritesGrantsName ?? ""}
                hasPageBefore={true}
                pageBeforeName={"Recomendação"}
                linkPageBefore={`/recommendations/${id}`}
            />
            <div className='card-body mt-4'>
                <div className='mb-4 d-flex align-items-center justify-content-between'>
                    <AutoComplete
                        popupMatchSelectWidth={true}
                        className="w-100 pe-0"
                        onSearch={(val) => { setSearch(val) }}
                    >
                        <Input.Search onBlur={() => company.potential === 0 ? getAllProjectsByLine() : getAllProjectGroupingByLine()} showCount={false} className="white" loading={loading} placeholder={company.potential === 0 ? 'Pesquisar por Projetos...' : 'Pesquisar por Agrupamentos...'} enterButton />
                    </AutoComplete>
                </div>
                {company.potential === 0 ?
                    <Table
                        loading={loading}
                        showHeader={false}
                        rowKey="id"
                        pagination={{
                            pageSizeOptions: ['7', '10', '25', '50', '75', '100'],
                            showSizeChanger: true,
                            showTotal: (total) => `Total ${total} items`,
                            total: total,
                            pageSize: take,
                            onChange: (page, pageSize) => {
                                getAllProjectsByLine(page)
                            },
                            onShowSizeChange: (page, size) => {
                                setTake(size)
                            }
                        }}
                        dataSource={projects}
                        columns={projectsColumns}
                    />
                    :
                    <Table
                        loading={loading}
                        showHeader={false}
                        rowKey="id"
                        pagination={{
                            pageSizeOptions: ['7', '10', '25', '50', '75', '100'],
                            showSizeChanger: true,
                            showTotal: (total) => `Total ${total} items`,
                            total: total,
                            pageSize: take,
                            onChange: (page, pageSize) => {
                                getAllProjectGroupingByLine(page)
                            },
                            onShowSizeChange: (page, size) => {
                                setTake(size)
                            }
                        }}
                        dataSource={projectGroupings}
                        columns={projectGroupingColumns}
                    />
                }
            </div>
        </div>
    )
}